import styled from 'styled-components'

import { BodyM } from '@/components/Text.tsx'

export const LoadMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
`

export const Description = styled(BodyM)`
  margin-bottom: 24px;
`
